import { type UseQueryResult, useQuery } from 'react-query';
import { GrantLegacyService, GrantService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetGrantPlanTypeList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string | undefined
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const grantPlanTypeList = useQuery(
    ['getGrantPlanTypeList', id],
    async () => {
      if (id != null && id !== '') {
        return await handleRequest(
          GrantLegacyService.getApiAwardApiAppGrantLegacyPlanTypesByPlanId(id)
        );
      }
      return await handleRequest(GrantService.getApiAwardApiAppGrantPlanTypes());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return grantPlanTypeList;
};

export default useGetGrantPlanTypeList;
